import React from "react";
import { BoxContainer } from "./ShadowComponents.elements";

export default function ShadowContainer({ children }: any) {
  return <BoxContainer>{children}</BoxContainer>;
}
